export const MAX_CONTRACT_DOCUMENTS = 20

export const CONTRACT_DOCUMENTS_LIMIT_TOOLTIP = `You can upload up to ${MAX_CONTRACT_DOCUMENTS} contracts. Delete an existing file to add a new one.`
